import { TUTORIAL_VIDEO_URL } from '../links';

const factoringVideoData = {
  title: '¿Cómo anticipar tus facturas en la plataforma?',
  description: 'Revisa el siguiente video para ver cómo en simples pasos puedes adelantar tus facturas en nuestra plataforma.',
  video: TUTORIAL_VIDEO_URL,
  image: '/images/factoring_tutorial.webp',
};

export default factoringVideoData;
